module.exports = __webpack_public_path__ + "images/courses-nav-mobile.png";


//////////////////
// WEBPACK FOOTER
// ./vively/images/courses-nav-mobile.png
// module id = 859
// module chunks = 3